import React from 'react';
import {Icon} from 'antd';

import InstructionLayout, {
    InstructionSpotlight,
    InstructionStep
} from '../instruction-layout';


const submitApplicationItems = [
    {
        id: 'submit-application',
        number: 1,
        content: (
            <>
                В карточке нужного рейса нажмите
                <strong> «Подать заявку»</strong>.
            </>
        ),
        area: {
            top: 61.73,
            left: 77.98,
            width: 18.05,
            height: 5.36
        }
    }
];


const applicationFormItems = [
    {
        id: 'company',
        number: 1,
        content: (
            <>
                Если у вас несколько юридических лиц,
                выберите компанию, от имени которой
                подаёте заявку.
            </>
        ),
        area: {
            top: 41.8,
            left: 6.4,
            width: 84,
            height: 6.5
        }
    },
    {
        id: 'loading-date',
        number: 2,
        content: (
            <>
                Оставьте предложенную дату загрузки
                или укажите свою.
            </>
        ),
        area: {
            top: 54.2,
            left: 6.4,
            width: 20,
            height: 6.5
        }
    },
    {
        id: 'rate',
        number: 3,
        content: (
            <>
                Оставьте текущую ставку либо предложите
                свою. При необходимости выберите вариант
                работы с НДС.
            </>
        ),
        area: {
            top: 54.2,
            left: 27.8,
            width: 30.4,
            height: 6.5
        }
    },
    {
        id: 'prepayment',
        number: 4,
        content: (
            <>
                При необходимости укажите размер
                <strong> предоплаты</strong>.
            </>
        ),
        area: {
            top: 54.2,
            left: 59.6,
            width: 30.8,
            height: 10.9
        }
    },
    {
        id: 'comment',
        number: 5,
        content: (
            <>
                Оставьте комментарий грузовладельцу
                по рейсу или задайте интересующий вопрос.
            </>
        ),
        area: {
            top: 68.7,
            left: 6.4,
            width: 84,
            height: 13.4
        }
    },
    {
        id: 'send',
        number: 6,
        content: (
            <>
                Проверьте условия заявки и нажмите
                <strong> «Отправить»</strong>.
            </>
        ),
        area: {
            top: 88.2,
            left: 40.75,
            width: 17.37,
            height: 5.65
        }
    }
];


const counterofferNotificationItems = [
    {
        id: 'counteroffer-notification',
        number: 1,
        content: (
            <>
                Если грузовладелец предложил другие условия,
                на сайте появится уведомление с новой ставкой.
            </>
        ),
        area: {
            top: 43,
            left: 14,
            width: 72,
            height: 18
        }
    }
];


const counterofferActionItems = [
    {
        id: 'counteroffer',
        number: 1,
        content: (
            <>
                Откройте рейс и проверьте встречное
                предложение грузовладельца.
            </>
        ),
        area: {
            top: 80.8,
            left: 77.6,
            width: 18.7,
            height: 8.1
        }
    },
    {
        id: 'accept-counteroffer',
        number: 2,
        content: (
            <>
                Если новые условия вас устраивают,
                нажмите <strong>«Принять»</strong>.
            </>
        ),
        area: {
            top: 89.03,
            left: 77.98,
            width: 8.63,
            height: 7.52
        }
    },
    {
        id: 'decline-counteroffer',
        number: 3,
        content: (
            <>
                Если условия не подходят,
                нажмите <strong>«Отклонить»</strong>.
            </>
        ),
        area: {
            top: 89.03,
            left: 87.75,
            width: 8.85,
            height: 8.04
        }
    }
];


export default function BidSubmissionInstruction() {
    return (
        <InstructionLayout title="Подача ставок">
            <p className="instruction-intro">
                На рейс можно подать заявку на условиях
                грузовладельца или предложить свои:
                изменить дату загрузки, ставку,
                размер предоплаты и добавить комментарий.
                Если грузовладелец предложит встречные условия,
                вы сможете принять или отклонить их.
            </p>

            <InstructionStep
                number="1"
                title="Подайте заявку на рейс"
            >
                <div className="instruction-copy">
                    <p>
                        Найдите подходящий рейс и раскройте
                        его карточку. Для перехода к форме
                        подачи заявки нажмите соответствующую
                        кнопку в правой части карточки.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/bid-submission/01-submit-application.png"
                    alt="Кнопка подачи заявки в карточке рейса"
                    items={submitApplicationItems}
                />
            </InstructionStep>

            <InstructionStep
                number="2"
                title="Укажите условия заявки"
            >
                <div className="instruction-copy">
                    <p>
                        В открывшемся окне проверьте данные
                        рейса и укажите условия, на которых
                        готовы выполнить перевозку.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/bid-submission/02-application-form.png"
                    alt="Форма подачи заявки на рейс"
                    items={applicationFormItems}
                />
            </InstructionStep>

            <InstructionStep
                number="3"
                title="Дождитесь ответа грузовладельца"
            >
                <div className="instruction-copy">
                    <p>
                        После отправки заявки дождитесь решения
                        грузовладельца. Он может сразу принять
                        предложенные условия либо отправить
                        вам встречное предложение.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/bid-submission/03-counteroffer-notification.png"
                    alt="Уведомление о встречном предложении грузовладельца"
                    items={counterofferNotificationItems}
                />

                <div className="service-note">
                    <Icon
                        className="service-note__icon"
                        type="info-circle"
                    />

                    <p className="service-note__text">
                        Уведомления о встречных предложениях
                        могут приходить на сайт, в приложение,
                        на электронную почту, в MAX и Telegram
                        в зависимости от выбранных вами
                        настроек уведомлений.
                    </p>
                </div>
            </InstructionStep>

            <InstructionStep
                number="4"
                title="Ответьте на встречное предложение"
            >
                <div className="instruction-copy">
                    <p>
                        Если грузовладелец предложил свои условия,
                        откройте рейс и выберите дальнейшее действие.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/bid-submission/04-counteroffer-actions.png"
                    alt="Встречное предложение грузовладельца в карточке рейса"
                    items={counterofferActionItems}
                />

                <div className="service-note">
                    <Icon
                        className="service-note__icon"
                        type="check-circle"
                    />

                    <p className="service-note__text">
                        Если грузовладелец сразу принял вашу заявку,
                        отвечать на встречное предложение не нужно.
                        После успешного согласования условий рейс
                        переходит во вкладку
                        <strong> «Мои рейсы»</strong>,
                        где его можно оформить.
                    </p>
                </div>
            </InstructionStep>
        </InstructionLayout>
    );
}
